import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export async function openExternalUrl(url) {
  if (!url) throw new Error("URL mancante");

  if (isNativeApp()) {
    await Browser.open({ url });
    return;
  }

  window.location.href = url;
}

/**
 * onClick per un <a> che punta a un sito esterno (es. www.stirup.it).
 * - Nativo (Capacitor): preventDefault + apertura nel browser di sistema,
 *   altrimenti l'utente resterebbe intrappolato nella webview.
 * - Web: nessun intervento, si lascia il comportamento dell'<a target="_blank">
 *   (nuova scheda).
 */
export function handleExternalAnchorClick(e, url) {
  if (!url) return;
  if (isNativeApp()) {
    e.preventDefault();
    openExternalUrl(url).catch(() => {});
  }
}
